<nz-modal
  [(nzVisible)]="isVisible"
  nzTitle="Practice Ended"
  [nzOkText]="'See Report'"
  (nzOnOk)="handleOk()"
  [nzCancelText]="null"
  [nzClosable]="isClosable"
  [nzMaskClosable]="isClosable"
  [nzCloseOnNavigation]="isClosable"
  [nzCancelDisabled]="!isClosable"
>
  <ng-container *nzModalContent>
    <div class="vertical-large center left">
      <!-- <h1>Meeting Ended!</h1> -->
      <!-- <div>How satisfied are you?</div>

      <div class="vertical rating">
        <nz-rate [(ngModel)]="rate"></nz-rate>
      </div>

      <div>Give us feedback on your product! (Optional)</div>
      <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 6 }" [(ngModel)]="feedback"></textarea> -->
    </div>
  </ng-container>
</nz-modal>
